import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createProjectsActionsSlice, createProjectsDataSlice } from './slices'
import type { ProjectsStore } from './types'

export const useProjectsStore = create<ProjectsStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createProjectsDataSlice(...args),
        ...createProjectsActionsSlice(...args),
      }))
    ),
    {
      name: 'ProjectsStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
